import React, { useEffect } from "react";
import { connect } from "react-redux";

import BackLogs from "./BackLogs";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../../redux/actions/menuActions";
import Menu from "../Menu";
const BackLogsContainer = props => {
  useEffect(() => {
    props.setMenuTopIndex("devs");
    props.setMenuLeftContent(Menu);
    props.setMenuLeftIndex("backlogs");
    props.setMenuLeftItemIndex("");
  }, []);
  if (!props.available) return <div>Vous n'avez pas accès à cette page</div>;
  return <BackLogs {...props} />;
};

const mapStateToProps = state => {
  const { email } = state.userInfos;
  const available = email === "tsirizo.rabenoro@upsell.fr";
  return {
    available,
    token: state.auth.token
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BackLogsContainer);



// WEBPACK FOOTER //
// src/pages/devs/backLogs/BackLogs.container.js